import script from "./AdminPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPasswordView.vue?vue&type=style&index=0&id=446d764d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446d764d"]])

export default __exports__